import customTheme from "../../../theme";

export const snackbarStyles = {
  "& .MuiLink-root": {
    color: customTheme.paleta.gris100,
    fontSize: 14,
    paddingRight: customTheme.spacing(1.5),
    fontWeight: 400,
    letterSpacing: "normal",
    cursor: "pointer",
    textDecorationColor: customTheme.paleta.gris100,
  },
  "& .MuiButton-root": {
    color: customTheme.paleta.gris100,
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: "normal",
    "&:hover": {
      backgroundColor: "transparent",
      color: customTheme.paleta.gris100,
    },
  },
  "& .MuiIconButton-root": {
    color: customTheme.paleta.gris100,
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: "normal",
    "&:hover": {
      backgroundColor: "transparent",
      color: customTheme.paleta.gris100,
    },
  },
  "& .SnackbarItem-variantSuccess": {
    backgroundColor: customTheme.paleta.success30,
  },
  "& .SnackbarItem-variantInfo": {
    backgroundColor: customTheme.paleta.info30,
  },
  "& .SnackbarItem-variantError": {
    backgroundColor: customTheme.paleta.error30,
  },
  "& .SnackbarItem-variantWarning": {
    backgroundColor: customTheme.paleta.warning30,
    color: customTheme.paleta.gris0,
  },
};

export default snackbarStyles;
